import { createGlobalStyle } from "styled-components";
import { device } from "../constants";

export const theme = {
	colors: {
		white: "#FFF",
		"branding-01": "#ABC616",
		"branding-02": "#6AB026",
		"branding-04": "#4E4B98",
		"vivid-01": "#CEFF00",
		"vivid-02": "#9FE870",
		"vivid-03": "#0AE1FF",
		"vivid-04": "#7D72FF",
		"neutral-01": "#FFFFFF",
		"neutral-02": "#D2D2D2",
		"neutral-03": "#A3A6A6",
		"neutral-04": "#7F7F7F",
		"neutral-05": "#394040",
		"neutral-06": "#2A2E3A",
		"neutral-07": "#1D202A",
		"neutral-08": "#000104",
		"background-01": "#1F1E2F",
		"background-02": "#15191E",
		"background-03": "#EAEAEA",
		"vz-background-01": "#FAFAFA",
		"vz-background-03": "#F3F3F3",
		error: "#FF3938",
	},
	fonts: {
		"hind-madurai": "Hind Madurai",
	},
};

export const FaceLiftGlobalStyle = createGlobalStyle`
  * {
    font-family: ${({ theme }) => theme.fonts["hind-madurai"]};
  }

  body, input, textarea, select, button {
    font: 400 1rem "${({ theme }) => theme.fonts["hind-madurai"]}";
  }

  a, button {
    cursor: pointer;
  }

  .container-blog {
    max-width: 1440px;
    margin: 0 auto;
    padding: 40px 24px;

    @media ${device.laptop} {
      padding: 40px 80px;
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;
